// extracted by mini-css-extract-plugin
export default {"trips-summary-no-trips":"styles_trips-summary-no-trips__ggiLI"};